import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { VariableBenefitPaymentFrequencyEnum } from '../../../../../../models/enum/shared/variable-benefit-payment-frequency.enum';
import { RecurringPaymentInstruction } from '../../../../../../models/submissions/recurring-payment-instruction';
import { VbRecurringPaymentChangeTypeEnum } from '../vb-payment-change-submission-recurring-payments-card.component';
import { payingInstructionOrNull } from '../../../create-vb-payment-change-components/utils/vb-payment-change-payments-step.utils';

@Component({
  selector: 'app-vb-payment-change-submission-recurring-payment',
  templateUrl: './vb-payment-change-submission-recurring-payment.component.html',
  styleUrls: ['./vb-payment-change-submission-recurring-payment.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class VbPaymentChangeSubmissionRecurringPaymentComponent {
  @Input({ required: true }) frequency!: VariableBenefitPaymentFrequencyEnum;
  @Input({ required: true }) hasChanged!: boolean;
  @Input() changeType!: VbRecurringPaymentChangeTypeEnum;
  @Input({ transform: payingInstructionOrNull })
  activeRecurringPaymentInstruction: RecurringPaymentInstruction | null = null;
  @Input() scheduledRecurringPaymentInstruction: RecurringPaymentInstruction | null = null;
  protected readonly VbRecurringPaymentChangeTypeEnum = VbRecurringPaymentChangeTypeEnum;
}
